module.exports = __webpack_public_path__ + "img/energetyka-24.ae5624c1.svg";